import { Box, Typography, Button } from '@mui/material';
import { useMsal } from '@azure/msal-react';

const SignedOut = () => {
  const { instance } = useMsal();

  const handleSignIn = () => {
    instance.loginRedirect();
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '80vh',
        gap: 3
      }}
    >
      <Typography variant="h4" component="h1">
        You have been signed out
      </Typography>
      <Typography variant="body1" color="text.secondary">
        Thank you for using NASH. Click below to sign back in.
      </Typography>
      <Button
        variant="contained"
        color="primary"
        onClick={handleSignIn}
        sx={{ mt: 2 }}
      >
        Sign In
      </Button>
    </Box>
  );
};

export default SignedOut;
